<h1>Settings</h1>

<div>
  <h2>Cached databases</h2>
  <ul>
    <li *ngFor="let dbName of allDatabases">{{ dbName }}</li>
  </ul>
  <p>
    <button class="btn btn-primary" (click)="destroyAllLocalDatabases()">Clear cache</button>
  </p>
</div>

<div *ngIf="!!canCommand">
  <h2>Remote commands</h2>
  <p>
    Compact remote database.
    <br/>
    <button class="btn btn-primary" (click)="compactRemoteDatabase()">Compact</button>
  </p>
  <p>
    Broadcast the "clearCache" command to all clients.
    <br/>
    <button class="btn btn-primary" (click)="broadcastClearCacheCommand()">Reset all clients</button>
  </p>
</div>
<div *ngIf="!!canCommand">
  <h2>Results import tool.</h2>
  <p>
    <a class="btn btn-primary" [routerLink]="['/gepard/results-import']">Open</a>
  </p>
</div>
<div *ngIf="!!canCommand">
  <h2>Driver start number change tool.</h2>
  <p>
    <span *ngFor="let racePlan of racePlans$ | async; let last = last">
      <a class="btn btn-primary"
        [routerLink]="['/season/races', racePlan._id | toUntypedId, 'settings', 'start-number-change-tool']"
      >{{ racePlan.name }}</a>
      <span *ngIf="!last">&nbsp;</span>
    </span>
  </p>
</div>
